"use client";

import { createBooleanSetting } from "./create-boolean-setting";

export const GENERATION_EFFECTS_STORAGE_KEY = "flowmuse:show-generation-effects";
export const GENERATION_EFFECTS_EVENT = "flowmuse:show-generation-effects-changed";

/**
 * “生成特效”（节点生成/自动运行时的脉动光环）可见性。
 * 默认开启；通过共享外部 store 在同页与跨标签页间同步。
 */
const setting = createBooleanSetting({
  storageKey: GENERATION_EFFECTS_STORAGE_KEY,
  eventName: GENERATION_EFFECTS_EVENT,
  defaultValue: true,
});

export const readGenerationEffectsEnabled = setting.read;
export const writeGenerationEffectsEnabled = setting.write;
export const useGenerationEffects = setting.useValue;
